import { DragIcon, SettingsIcon } from 'assests/GmsIcons';
import React from 'react';
import ToggleEyeButton from './ToggleEyeButton';
import { CATEGORY } from 'Pages/GMS/ISR/ISRConstants';
import { TCategory } from '../ui';
import { colorTheme } from '../ColorTheme';

type TUICategoryItemProps = {
    category: TCategory;
    categoryIndex: number;
    modelIndex?: number;
    updateCategory: (category: TCategory, categoryIndex: number, modelIndex?: number) => void;
    dragHandleProps?: any;
    setCategoryEditFlag?: any;
    setEditCategory?: any;
}

const UICategoryItem = ({category, updateCategory, categoryIndex, modelIndex, dragHandleProps, setCategoryEditFlag, setEditCategory}: TUICategoryItemProps) => {

    const handleHiddenChange = () => {
        updateCategory({...category, isCategoryVisible: !category?.isCategoryVisible}, categoryIndex);
    }

    return (
        <div className='tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-[104px] tw-border-[2px] tw-border-solid tw-border-[#f4f4f7] tw-mt-2'>
            <div className="tw-flex tw-items-center tw-justify-between tw-rounded-t tw-rounded-b-none tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-[38px] tw-border-[1px] tw-border-solid tw-border-[#dadbdd] tw-px-3">
                <div className="tw-flex tw-items-center tw-gap-3">
                    {/* <DragIcon /> */}
                    <div {...dragHandleProps}>
                        <DragIcon />
                    </div>
                    <label className="tw-text-[#090A42] tw-text-sm tw-ml-4"
                        style={{color: colorTheme.title}}
                    >{category?.categoryName ?? ''}</label>
                </div>
                <div className="tw-flex tw-items-center tw-gap-3">
                    <ToggleEyeButton isClicked={category?.isCategoryVisible ?? false} onClick={handleHiddenChange} />
                    <button className={`tw-focus:outline-none`} onClick={()=>{
                        setEditCategory({ category: category, categoryIndex: categoryIndex, modelIndex: modelIndex })
                        setCategoryEditFlag(true)
                    }}>
                        <SettingsIcon />
                    </button>
                    {/* <DeleteIcon /> */}
                </div>
            </div>
            <div className='tw-flex tw-justify-between tw-text-center tw-items-center tw-mt-2.5'>
                <div className="tw-rounded tw-bg-[#f4f4f7] tw-box-border tw-w-[440px] tw-flex tw-flex-row tw-items-center tw-justify-start tw-py-2 tw-px-2.5 tw-gap-[10px] tw-text-sm tw-border-[1px] tw-border-solid tw-border-[#ebecf0] tw-ms-3"
                    style={{backgroundColor: colorTheme.background}}
                >{category?.categoryName ?? ''}</div>
                    <div className='tw-flex tw-me-3'>
                        <input disabled={true} placeholder={CATEGORY}  className="tw-rounded tw-bg-shades-of-grey-20 tw-box-border tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-py-2 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"/>
                    </div>
            </div>
        </div>
    );
}

export default UICategoryItem;